<div class="container">
  <h1 class="page-title">Available Scholarships</h1>

  @if (featured$ | async; as featured) {
    @if (featured.length > 0) {
      <div class="scholarship-grid">
        @for (scholarship of featured; track scholarship) {
          <div class="scholarship-card">
            <div class="scholarship-image" [style.background-image]="'url(' + getImageUrl(scholarship) + ')'">
            </div>
            <div class="scholarship-content">
              <h3 class="scholarship-title">
                {{ scholarship.title }}
              </h3>
              <div class="scholarship-meta">
                <span><i class="fas fa-money-bill-wave"></i> {{
                scholarship.scholarshipTemplate.country.currencySymbol }} {{ scholarship.allocatedFunds |
              number:'1.2-2' }}</span>
              <span><i class="fas fa-graduation-cap"></i> {{ scholarship.category.name }}</span>
            </div>
            <p class="scholarship-description" [innerHTML]="sanitize(scholarship.description)"></p>
            <div class="scholarship-footer">
              <span class="scholarship-deadline"><i class="fas fa-calendar-alt"></i>
              Deadline: <strong>{{ scholarship.deadline | date:'EEEE, d MMMM yyyy' }}</strong>
            </span>
              <a [routerLink]="['/scholarships', scholarship.id]" class="btn-apply">View Details</a>
            </div>
        </div>
      </div>
    }
  </div>
} @else {
  <div class="no-scholarships">
    <div class="no-scholarships-card">
      <div class="no-scholarships-icon">
        <i class="fas fa-graduation-cap"></i>
      </div>
      <p>No scholarships available at the moment. Please check again later.</p>
    </div>
  </div>
}
} @else {
  <div class="no-scholarships">
    <div class="no-scholarships-card">
      <div class="no-scholarships-icon">
        <i class="fas fa-graduation-cap"></i>
      </div>
      <p>No scholarships available at the moment. Please check again later.</p>
    </div>
  </div>
}

</div>
